import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import "react-pro-sidebar/dist/css/styles.css";
import { useSelector } from "react-redux";

import Sidebar from "./sidebar";
import Alert from "../../components/alert";

import { Content } from "./style";

function Layout(props) {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(true);
  const [error, setError] = useState('Payment Method Does Not Exist!');
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (Object.keys(user?.payment)?.length || ['admin','affiliate-manager', 'agency-manager'].includes(user?.role)) {
      setError('');
    } else {
      setError('Payment Method Does Not Exist!');
    }
  }, [props.children])

  return (
    <>
      <div className="d-flex">
        <div className="sidebar-collapsed">
          <Sidebar collapsed={collapsed} />
        </div>
        <Content className="dashboard-content">
          {
            error && (
              <Alert
                buttonText="Add Payment Method"
                errorText={error}
                hide={() => setError('')}
                resolve={() => history.push('/payments')}
                marginBottom='3px'
              />
            )
          }
          <div>{props.children}</div>
        </Content>
      </div>
    </>
  );
}

export default Layout;
